import React, { useState } from 'react';
import { useRef, useEffect } from "react";


function AddressInput({ onSubmitAddress }) {

  const [address, setAddress] = useState('');
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  const options = {
      location: { lat: 36.9741, lng: -122.0308 }, // Santa Cruz coordinates
      radius: 16093.4, //approx 10 mile radius (in meters)
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Call the onSubmitAddress function and pass the address to it
    onSubmitAddress(address);
  };

  useEffect(() => {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options // this uses the const options defined above! 
    );

    autoCompleteRef.current.addListener("place_changed", async function () 
    {
      const place = await autoCompleteRef.current.getPlace();
      if (place && place.geometry && place.geometry.location) { // if place exists continue otherwise print debug
        console.log( place.formatted_address );
        // setAddress(place.formatted_address);

        const coordinates = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
        setAddress(coordinates);
        onSubmitAddress(coordinates); // Submit the coordinates whenever a place is selected

      }else{
        console.log("Place is undefined");
      }
      
    });

  }, []);

  return (
    <>
      <input ref={inputRef} />
    </>
  );
}

export default AddressInput;
